<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="paeroa">
<h1>Paeroa</h1>
<p style="text-indent: 00em;">We’ve been in Paeroa now nearly two years</p>
<p style="text-indent: 00em;">Really don’t miss Auckland apart from the free beers</p>
<p style="text-indent: 00em;">’Cause I worked in a brewery for a while</p>
<p style="text-indent: 00em;">And the free beer allocation did make my husband smile</p>
<p style="text-indent: 00em;">We love it in Paeroa because</p>
<p style="text-indent: 00em;">Being retired now, it’s made us pause</p>
<p style="text-indent: 00em;">And realise what is important to us</p>
<p style="text-indent: 00em;">It’s not buying things or making a fuss</p>
<p style="text-indent: 00em;">Our lives now are peaceful and uncomplicated</p>
<p style="text-indent: 00em;">Retirement to us was totally underrated</p>
<p style="text-indent: 00em;">We can work in the community and help people out</p>
<p style="text-indent: 00em;">And make a small difference, there is no doubt</p>
<p style="text-indent: 00em;">So, thank you Paeroa, for welcoming us here</p>
<p style="text-indent: 00em;">It’s the best decision we ever made that year</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?6e95e212